import type { Course, Progress } from '../../types/course';
import type { PublicCourse } from '../../types/cart';
import { MOCK_COURSES, MOCK_PROGRESS } from '../../constants/mockDashboard';
import { MOCK_COURSES as MOCK_CATALOG_COURSES } from '../../constants/mockCourses';
import type { ICourseService } from '../interfaces/ICourseService';
import { WeeklyStats } from '../../types/stats';

const delay = (ms = 500) => new Promise((r) => setTimeout(r, ms));

// Stato in-memory per il progresso mock
let _progress: Progress[] = [...MOCK_PROGRESS];

export const courseMock: ICourseService = {
  getCatalog: async (): Promise<PublicCourse[]> => {
    // TODO: replace → GET /api/courses
    await delay(300);
    return MOCK_CATALOG_COURSES.map((c) => ({
      id: c.id,
      title: c.title,
      subtitle: c.subtitle ?? null,
      description: null,
      imageUrl: c.imageUrl ?? null,
      price: c.price,
      currency: 'EUR',
    }));
  },

  getMyCourses: async (): Promise<Course[]> => {
    await delay();
    return Object.values(MOCK_COURSES);
  },

  getCourse: async (courseId: string): Promise<Course> => {
    await delay();
    const course = MOCK_COURSES[courseId];
    if (!course) throw new Error('Corso non trovato.');
    return course;
  },

  getProgress: async (courseId: string): Promise<Progress | null> => {
    await delay(300);
    return _progress.find((p) => p.courseId === courseId) ?? null;
  },

  saveProgress: async (
    courseId: string,
    lessonId: string,
    secondsWatched: number,
    completed = false
  ): Promise<void> => {
    const existing = _progress.find((p) => p.courseId === courseId);
    if (existing) {
      existing.lessonId = lessonId;
      existing.secondsWatched = secondsWatched;
      existing.lastWatchedAt = new Date().toISOString();
      if (completed && !existing.completedLessonIds.includes(lessonId)) {
        existing.completedLessonIds.push(lessonId);
      }
    } else {
      _progress.push({
        userId: '',
        courseId,
        lessonId,
        secondsWatched,
        completedLessonIds: completed ? [lessonId] : [],
        lastWatchedAt: new Date().toISOString(),
        completionPercent: 0,
        lessons: undefined,
      });
    }
  },
  getWeeklyStats: async (): Promise<WeeklyStats> => {
    await delay(300);
    const today = new Date();
    return Array.from({ length: 7 }, (_, i) => {
      const d = new Date(today);
      d.setDate(today.getDate() - (6 - i));
      return {
        date: d.toISOString().slice(0, 10),
        secondsWatched: Math.floor(Math.random() * 2400), // 0–40 min mock
      };
    });
  },
};
